export default "__VITE_PUBLIC_ASSET__4a71882f__"